<div class="material-page">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
    
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative; width: 100%; max-width: 450px; height: auto; float: right">
          <img-with-placeholder [placeholder]="'/global_warming/global_warming_placeholder.webp' | assetUrl">
            <img 
                 ngSrc="/global_warming/global_warming.webp" 
                 ngSrcset="450w" 
                 fullSizedImage
                 sizes="100vw, 450px"
                 width="450" 
                 height="450"/>
          </img-with-placeholder>
        </div>
      
        <h1 class="mat-headline-2" i18n>The Magic Bullet</h1>
        <p i18n>Climate change is a complex issue, influenced by numerous factors, not all of which can be directly addressed. However, there is an area where just a simple shift in our daily habits can make a profound difference for our planet. That’s overconsumption.</p>
        <p i18n>Today, the average consumer buys 64% more items than they did in the year 2000 and uses them for only about half as long. As a result, homes are full of unused things and people in the developed world alone sit on more than $1 trillion worth of unused things (that’s on average 184 items per household worth $5,000).</p>
        <br/>
        <h1 class="mat-headline-2" i18n>Your Most Valuable Contribution</h1>
        <p i18n>Our mission is to make selling used items completely effortless so unwanted things would no longer get stored away just because selling them feels like a chore. Studies show that in a well functioning circular economy where unused items effortlessly find new owners, carbon-dioxide emissions could drop as much as 48 percent from 2012 levels by 2030.</p>
        <p i18n>Taking a moment to go through your belongings and identifying items you no longer need could be one of the most significant contributions you make to our planet.</p>
        <br/>
        <h1 class="mat-headline-2" i18n>Let’s build it together</h1>
        <p i18n>We understand that while changing habits can be challenging, most of us are genuinely willing to contribute to the fight against overconsumption and climate change. That's why we're dedicated to making reselling as easy as possible, from both a human and technological standpoint. Our goal is to seamlessly integrate this practice into our busy lives.</p>
        <p i18n>Please share your suggestions on how we can simplify the process for you to rejuvenate your unused items. Together, we can make a difference.</p>
      </div>
      
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <img [src]="'/priit.png' | assetUrl"/>
        <div>Priit Viru (Co-founder)</div>
        <div>priit.viru&#64;listx.ai</div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <img [src]="'/erki.png' | assetUrl"/>
        <div>Erki Kert (Co-founder)</div>
        <div>erki.kert&#64;listx.ai</div>
      </div>
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4">
        <mat-icon fontSet="material-symbols-outlined" style="font-size: 65px; width: 65px; height: 65px">info</mat-icon>
        <div i18n>Customer support</div>
        <div>support&#64;listx.ai</div>
      </div>
    </div>
  </div>
</div>